module.exports = __webpack_public_path__ + "img/24.fedd4808.jpg";